import {Component, OnInit} from '@angular/core';
import {BaseConfigurableComponent} from '@twpub/shared/components/base';
import {ClientConfigurationScheme, ComponentConfiguration, ComponentInit, InitialConfig} from '@twpub/core/utils';
import {ComponentCategory, ControlType} from '@twpub/core/enums';
import {FieldProps, Footer, Header} from '@twpub/core/models';
import {TITLE} from '@twpub/core/constants';
import {environment} from '../../../../../environments/environment';
import { NgClass, NgStyle } from '@angular/common';
import {MarkdownComponent} from 'ngx-markdown';

@Component({
  selector: 'pub-default-footer',
  templateUrl: './default-footer.component.html',
  styleUrls: ['./default-footer.component.scss'],
  standalone: true,
  imports: [NgClass, NgStyle, MarkdownComponent]
})
export class DefaultFooterComponent extends BaseConfigurableComponent implements OnInit, Footer {
  title = TITLE;
  versionStr = 'v' + environment.appVersion + '  (build ' + environment.buildNumber + ')'
  versionVisible = false; // Initial state
  text?: string;

  static Init = class extends ComponentInit {
    readonly scheme = ClientConfigurationScheme.DEFAULT;
    override props: FieldProps[] = [this.VISIBLE_FIELD,
      {
        key: 'text',
        label: 'Footer text',
        controlType: ControlType.Textarea,
        description: 'Footer text content. Markdown syntax is supported.'
      }
    ];

    constructor() {
      super(DefaultFooterComponent, 'DefaultFooterComponent', 'Default footer', [ComponentCategory.Footer]);
    }

    createConfig(initialConfig: InitialConfig = undefined) {
      return new ComponentConfiguration<Header>(DefaultFooterComponent, this.name, initialConfig);
    }
  }

  ngOnInit(): void {
    this.doUpdate()
  }

  override doUpdate() {
    super.doUpdate();
    this.text = this.config?.getString('text');
  }

  showVersion() {
    this.versionVisible = true;
  }

  hideVersion() {
    this.versionVisible = false;
  }
}
